export function openUberEatsOrderTrackingUrlInNewTab(uberEatsOrderTrackingUrl?: string): void {
    if (!uberEatsOrderTrackingUrl) return;
    window.open(uberEatsOrderTrackingUrl, '_blank');
}
